
<main>
    <div class="jobs">
        <div class="post-job cursorClass">
            <a (click)="addEventDonor()" *ngIf="userTypeId == 1">
                <i class="ti ti-circle-plus"></i>
                <h4>કાર્યક્રમ દાતાઓની નોંધણી કરો</h4>
            </a>
        </div>
        <h4>કાર્યક્રમ દાતાઓ યાદી</h4>
        <hr>
        <div class="filtering">
            <form>
                <input placeholder="શોધો..." type="search" #filter (keyup)="applyFilter($event)" class="form-control"
                    aria-label="Search box">
                <i class="ti ti-search"></i>
            </form>

            <!-- <a class="ti ti-refresh" (click)="getSubEventListData()"></a> -->
        </div>
        <div>
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of getEventDonorList">
                    <div class="flex1">
                        <h5>{{data.member_name}}</h5>
                        <small>કાર્યક્રમ : {{data.sub_event_name}}</small><br>
                    </div>
                    <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin"
                        [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)" *ngIf="userTypeId == 1">
                    </mat-slide-toggle>
                </a>
            </div>
        </div>
    </div>
</main>